document.addEventListener('DOMContentLoaded', function () {
  const giftSaveButton = document.querySelector('#cart-gift-box-save-btn')

  // Event listener for checkbox change
  document.addEventListener('change', function (event) {
    if (event.target.matches('.gifting-option-checkbox-input')) {
      const el = event.target
      const parents = el.closest('.cart-gift-drawer-items')
      const errorContainer = document.querySelector('#gift-drawer-error-message')

      if (el.checked === true) {
        parents.setAttribute('data-item-cart-action', 'add')
      } else {
        parents.setAttribute('data-item-cart-action', 'remove')
      }

      // Undoes the disabled state that is added when gift box quantity is invalid
      errorContainer.style.display = 'none'
      giftSaveButton.removeAttribute('disabled')
    }
  })

  // Event listener for textarea
  document.addEventListener('change', function (event) {
    if (event.target.matches('.cart-gifting-drawer-textarea')) {
      const el = event.target
      const parents = el.closest('.cart-gift-drawer-items')

      // Only need to update note, not add new lines
      parents.setAttribute('data-item-cart-action', 'update')
    }
  })

  closeDrawer = () => {
    const cartGiftOptionDrawer = document.querySelector(
      'cart-gift-option-drawer'
    )
    cartGiftOptionDrawer.classList.remove('open')
    GiftUtils.setBodyOverflowHidden(false)
  }

  // Use event delegation to handle dynamically added buttons
  document.addEventListener('click', function (event) {
    if (event.target.matches('#cart-gift-box-save-btn')) {
      // Also keep the original check for backwards compatibility
      if (giftSaveButton) {
        let dataObject = []
        const clickedElement = event.target

        if (clickedElement.getAttribute('type') == 'submit') {
          // Check that the desired gift box quantity is valid.
          if (!isGiftBoxQuantityValid()) {
            const errorContainer = document.querySelector(
              '#gift-drawer-error-message'
            )

            errorContainer.style.display = 'block'
            errorContainer.innerHTML = window.giftingStrings.outOfStockError
            giftSaveButton.setAttribute('disabled', 'disabled')
            return
          }

          const drawerWrap = clickedElement.closest('.cart-gift-option-drawer')
          const timestampItemKeyMap = {}

          /**
           * Store a count value that gets incremented in each loop.
           * - Helps ensures that the groupId is unique when multiple edits are
           *   triggered at once.
           */
          let count = 0
          const cartGiftDrawerItems = drawerWrap.querySelectorAll('.cart-gift-drawer-items')
          cartGiftDrawerItems.forEach(function (item) {
            const actionType = item.getAttribute('data-item-cart-action')
            const itemKey = item.getAttribute('data-itemkey')
            const parentId = item.getAttribute('data-id')
            const groupId = item.getAttribute('data-group-id')
            const quantity = item.getAttribute('data-line-quantity')
            const isAddon = item.getAttribute('data-is-addon') === 'true'
            const addonType = item.getAttribute('data-addon-type')

            /**
             * Get item properties as an object.
             * - Retrieve properties from data attribute.
             * - Parse string to JSON
             * - Convert JSON array of key pair values into an object using
             *   `Object.fromEntries`
             * - Existing properties object is used to ensure existing non-gift
             *   properties remain on the product after updates.
             */
            const existingPropertiesAttribute = item.getAttribute('data-properties')
            const existingPropertiesJSON = JSON.parse(existingPropertiesAttribute)
            const existingProperties = Object.fromEntries(existingPropertiesJSON)

            if (actionType != 'added') {
              const checkboxInput = item.querySelector('input')
              if (checkboxInput && checkboxInput.checked) {
                // Get the newly selected gift box variant ID from the checked radio button
                const checkedGiftBoxInput = item.querySelector('.gifting-option-checkbox-input:checked')
                const newlySelectedGiftId = checkedGiftBoxInput
                  ? checkedGiftBoxInput.value
                  : item.getAttribute('data-gift-box-id') // fallback to existing gift box

                // Use the newly selected gift box ID
                const giftId = newlySelectedGiftId

                const giftBoxExist = item.getAttribute('data-gift-item-exist')

                // Get the newly selected gift box handle from the checked radio button
                const newlySelectedGiftHandle = checkedGiftBoxInput
                  ? checkedGiftBoxInput.getAttribute('data-product-handle')
                  : item.getAttribute('data-product-handle') // fallback to existing handle

                const giftProductHandle = newlySelectedGiftHandle
                const noteDiv = item.querySelector(
                  '.gifting-drawer-textarea-box textarea'
                )
                const noteValue = noteDiv ? noteDiv.value : ''

                const dateNow = Date.now()
                const newGroupId = groupId || dateNow + count * 1000
                count++

                // Validate that we have all required IDs
                if (!parentId) {
                  console.error('parentId is null or undefined:', parentId)
                  return
                }
                if (!giftId) {
                  console.error('giftId is null or undefined:', giftId)
                  return
                }
                if (!itemKey) {
                  console.error('itemKey is null or undefined:', itemKey)
                  return
                }

                /**
                 * Split or replace approach:
                 * - If qty > 1: reduce existing line by 1 (keeps it without gift props),
                 *   then add a new line with qty 1 + gift properties.
                 * - If qty == 1: remove existing line entirely and re-add with gift properties.
                 * - If gift box already exists, also remove and re-add it.
                 */

                const currentQuantity = parseInt(quantity)

                // Reduce or remove the existing main product
                const removeMainProductLine = {
                  actionType: 'update',
                  id: itemKey,
                  quantity: currentQuantity > 1 ? currentQuantity - 1 : 0,
                }

                // Add a single unit with gift properties
                const addMainProductLine = {
                  actionType: 'add',
                  id: parseInt(parentId), // Ensure ID is a number
                  quantity: 1,
                  properties: {
                    ...existingProperties,
                    Note: noteValue,
                    _hasGiftBox: 'true',
                    _giftPid: giftId,
                    _groupId: newGroupId,
                    _giftProductHandle: giftProductHandle,
                  },
                }

                if (giftBoxExist == 'true') {
                  const existingGiftBoxId = item.getAttribute('data-gift-box-id')

                  // If data attribute is missing we can't target the old gift box –
                  // treat this case as "no gift yet" to avoid sending an update with
                  // an empty id which breaks the cart API.
                  if (!existingGiftBoxId) {
                    GiftUtils.log('expected data-gift-box-id but none found – skipping removal');
                  }

                  const giftChanged = existingGiftBoxId && giftId != existingGiftBoxId

                  if (giftBoxExist === 'true' && !giftChanged) {
                    // Mark its gift-box row as UPDATE on the current .cart-gift-drawer-items element
                    item.setAttribute('data-item-cart-action', 'update')
                  }

                  if (giftChanged) {
                    // Remove old gift and add the newly selected one
                    // Only push a removal if we have a valid line-item id.
                    const removeGiftProductLine = existingGiftBoxId ? {
                      actionType: 'update',
                      id: existingGiftBoxId,
                      quantity: 0,
                    } : null;

                    const addGiftProductLine = {
                      actionType: 'add',
                      id: parseInt(giftId),
                      quantity: 1,
                      properties: {
                        _parentPid: parentId,
                        _groupId: newGroupId,
                        _addon: 'true',
                        _addonType: 'Gift Box',
                        _giftProductHandle: giftProductHandle,
                      },
                    }

                    if (removeGiftProductLine) {
                      dataObject.push(removeMainProductLine, removeGiftProductLine, addMainProductLine, addGiftProductLine)
                    } else {
                      dataObject.push(removeMainProductLine, addMainProductLine, addGiftProductLine)
                    }
                  } else {
                    // Gift box unchanged. Update main product only (note or other properties)
                    const cleanedProps = { ...existingProperties };
                    cleanedProps.Note = noteValue;

                    const updateMainProductLine = {
                      actionType: 'update',
                      id: itemKey,
                      quantity: parseInt(quantity),
                      properties: cleanedProps,
                    }

                    // Replace entire dataObject with just the single update
                    dataObject = [updateMainProductLine];
                    // Exit the .each loop early
                    return false;
                  }
                } else if (actionType !== 'update') {
                  // Only add gift box when user has (re)checked the option
                  const addGiftProductLine = {
                    actionType: 'add',
                    id: parseInt(giftId),
                    quantity: 1,
                    properties: {
                      _parentPid: parentId,
                      _groupId: newGroupId,
                      _addon: 'true',
                      _addonType: 'Gift Box',
                      _giftProductHandle: giftProductHandle,
                    },
                  }

                  dataObject.push(removeMainProductLine, addMainProductLine, addGiftProductLine)
                }
              } else if (actionType === 'remove') {
                /**
                 * Remove old product and add new one when removing a gift box
                 * - Remove the existing product completely
                 * - Add it back without gift box properties
                 * - If the product has personalisation, keep the groupId
                 *   so that main product and personalisation remain linked.
                 */

                const hasPersonalisation = Boolean(
                  existingProperties[
                    window.personalisationStrings?.initialsProperty
                  ]
                )

                const newProperties = { ...existingProperties }

                // Validate that we have all required IDs
                if (!parentId) {
                  console.error('parentId is null or undefined:', parentId)
                  return
                }
                if (!itemKey) {
                  console.error('itemKey is null or undefined:', itemKey)
                  return
                }

                /**
                 * Remove old product and add new one approach:
                 * - First remove the existing product by setting quantity to 0
                 * - Then add the new product with updated properties
                 * - If gift box already exists, also remove and re-add it
                 */

                // Remove the existing main product
                const removeMainProductLine = {
                  actionType: 'update',
                  id: itemKey,
                  quantity: 0,
                }

                // Add the main product back without gift box properties
                const addMainProductLine = {
                  actionType: 'add',
                  id: parseInt(parentId), // Ensure ID is a number
                  quantity: parseInt(quantity),
                  properties: newProperties,
                }

                // Always attempt to remove the linked gift box using data attribute fallback
                const fallbackGiftId = item.getAttribute('data-gift-box-id')
                if (fallbackGiftId) {
                  dataObject.push({ actionType: 'update', id: fallbackGiftId, quantity: 0 })
                }

                dataObject.push(removeMainProductLine, addMainProductLine)

                // By now we should already have a gift to remove
                const giftKey = timestampItemKeyMap[groupId]
                if (giftKey) {
                  const payloadForGiftBoxRemove = {
                    actionType: 'update',
                    id: giftKey,
                    quantity: 0,
                  }

                  dataObject.push(payloadForGiftBoxRemove)
                }
              } else if (groupId && isAddon && addonType === 'Gift Box') {
                timestampItemKeyMap[groupId] = itemKey
              }
            }
          })

          // Check dataObj length
          if (dataObject.length > 0) {
            try {
              const selected = drawerWrap.querySelector('.gifting-option-checkbox-input:checked');
              GiftUtils.log('Selected gift', {
                id: selected?.value,
                handle: selected?.getAttribute('data-product-handle'),
              });
            } catch (e) {}
            // Setting aria label attribute
            clickedElement.setAttribute('aria-disabled', 'true')

            // Log payload for debugging in a structured manner
            GiftUtils.log('Cart payload (pre-dedupe)', dataObject)

            // Adding loading state
            clickedElement.classList.add('loading')
            GiftUtils.setCartLoading(true)
            const unique = [];
            const seen = new Set();
            dataObject.forEach(op => {
              if (op.actionType === 'add' && seen.has(op.id)) return;
              if (op.actionType === 'add') seen.add(op.id);
              unique.push(op);
            });
            // Extra logging after duplicate-removal so we can follow exactly
            // which lines will be sent to the cart API.
            GiftUtils.log('Cart payload (deduped)', unique)

            // Highlight just the gift-box lines for quick scanning.
            unique
              .filter(op => op.properties && op.properties._addonType === 'Gift Box')
              .forEach(op => GiftUtils.log('GiftBox line item', op))

            GiftUtils.log('Cart payload (final to send)', unique)
            addAllItems(unique, clickedElement)
          } else {
            // Close the drawer
            closeDrawer()
          }
        }
      }
    }
  })

  /**
   * Check if the user's requested gift box stock is valid.
   * - Loops through the gift lines to get the following:
   *   - Whether the product has a linked gift box item
   *   - The current stock of the linked gift box item, added as a data
   *     attribute `data-gift-box-quantity`
   *     - The stock level is set to Infinity if Shopify is not tracking stock,
   *       grabbed from a data attribute `data-gift-box-check-quantity`
   *   - The desired stock, calculated from the main product's quantity and
   *     whether the user is adding or updating a gift box, based on the
   *     `data-item-cart-action` attribute
   * - Then compares the desired stock against the inventory stock to make sure
   *   that for every gift box variant id the desired quantity is less that or\
   *   equal to the available stock
   * @returns {Boolean} whether requested gift box stock amount is valid
   */
  function isGiftBoxQuantityValid() {
    const drawerElement = document.querySelector('.cart-gift-option-drawer')
    const lineItems = drawerElement.querySelectorAll('.cart-gift-drawer-items')

    // Set up objects to store desired and requested quantities.
    const giftBoxInventoryQuantity = {}
    const giftBoxDesiredQuantity = {}

    lineItems.forEach(lineItem => {
      const linkedGiftBoxId = lineItem.dataset.giftBoxId
      const linkedGiftBoxQuantity = lineItem.dataset.giftBoxQuantity
      const linkedGiftBoxCheckQuantity =
        lineItem.dataset.giftBoxCheckQuantity === 'true'

      if (!linkedGiftBoxId) {
        return
      }

      giftBoxInventoryQuantity[linkedGiftBoxId] = linkedGiftBoxCheckQuantity
        ? Number(linkedGiftBoxQuantity)
        : Infinity

      const itemQuantity = Number(lineItem.dataset.lineQuantity)
      const giftAdded = ['add', 'added'].includes(
        lineItem.dataset.itemCartAction
      )
      const desiredQuantity = giftAdded ? itemQuantity : 0

      giftBoxDesiredQuantity[linkedGiftBoxId] = giftBoxDesiredQuantity[
        linkedGiftBoxId
      ]
        ? giftBoxDesiredQuantity[linkedGiftBoxId] + desiredQuantity
        : desiredQuantity
    })

    const isQuantityValid = Object.keys(giftBoxDesiredQuantity).every(key => {
      return giftBoxDesiredQuantity[key] <= giftBoxInventoryQuantity[key]
    })

    return isQuantityValid
  }

  // Add to cart ajax for gift box products
  async function addAllItems(dataItems, $this) {
    /**
     * Sort cart updates to ensure proper order:
     * 1. First process all removals (updates with quantity 0)
     * 2. Then process all additions
     * - This ensures we free up inventory before trying to add new items
     * - Prevents stock conflicts when removing and adding gift boxes
     */
    const sortedCartUpdates = [...dataItems].sort((a, b) => {
      // Removals (updates with quantity 0) come first
      const aIsRemoval = a.actionType === 'update' && a.quantity === 0
      const bIsRemoval = b.actionType === 'update' && b.quantity === 0

      if (aIsRemoval && !bIsRemoval) return -1
      if (!aIsRemoval && bIsRemoval) return 1

      // Then regular updates
      if (a.actionType === 'update' && b.actionType !== 'update') return -1
      if (a.actionType !== 'update' && b.actionType === 'update') return 1

      // Finally additions
      if (a.actionType === 'add' && b.actionType !== 'add') return 1
      if (a.actionType !== 'add' && b.actionType === 'add') return -1

      return 0
    })

    for (let data of sortedCartUpdates) {
      const actionType = data.actionType
      const url =
        actionType === 'add' ? routes.cart_add_url : routes.cart_change_url

      // Log each individual request so we can trace its lifecycle.
      GiftUtils.log(`Cart ${actionType} request`, data)

      if (!data.id) {
        // Skip invalid operation silently
        continue
      }

      try {
        const response = await fetch(url, {
          ...fetchConfig(),
          body: JSON.stringify(data),
        })

        if (!response.ok) {
          // Shopify returns 422 when trying to update a line that no longer exists.
          // Treat that as success if we were attempting to remove it (quantity 0).
          if (response.status === 422 && data.actionType === 'update' && data.quantity === 0) {
            continue
          }

          const errorText = await response.text()
          console.error('Cart operation failed:', {
            status: response.status,
            statusText: response.statusText,
            error: errorText,
            data: data
          })
        }
      } catch (error) {
        console.error('Cart operation error:', error, 'Data:', data)
      }
    }

    // Reloading cart drawer contents and cart bubble in header.
    await updateCart()

    // Setting aria label attribute
    $this.setAttribute('aria-disabled', 'false')

    // Removing loading state
    $this.classList.remove('loading')
    GiftUtils.setCartLoading(false)

    closeDrawer()
  }

  /**
   * Fetch the latest cart state and update sections.
   * - Fetches the latest cart state and then updates the cart sections to show
   *   the new data.
   */
  function updateCart() {
    const cacheBuster = `&_=${Date.now()}`
    return fetch(
      `${routes.cart_url}?sections=${getSectionsToRender().map(
        section => section.section
      )}${cacheBuster}`,
      { cache: 'no-store' }
    )
      .then(response => response.text())
      .then(state => {
        const parsedState = JSON.parse(state)

        getSectionsToRender().forEach(section => {
          const elementToReplace =
            document
              .getElementById(section.id)
              .querySelector(section.selector) ||
            document.getElementById(section.id)

          elementToReplace.innerHTML = GiftUtils.parseSectionHTML(
            parsedState[section.section],
            section.selector
          )
        })
      })
      .catch(e => {
        console.error(e)
      })
  }

  function getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ]
  }

  // Function to check if the gift box or message has been added
  function checkGiftBoxSelection() {
    // These elements only exist on product pages, not in cart drawer context
    const selectedGiftBox = document.querySelector('#selected-gift-box')
    const giftBoxContent = selectedGiftBox ? selectedGiftBox.textContent.trim() : null
    const giftBox = document.querySelector(".gift-box-checkbox:checked");
    const giftMessage = document.querySelector('#gift-message')
    const giftMessageValue = giftMessage ? giftMessage.value.trim() : ''
    const giftBoxVariantInput = document.querySelector('#gift-box-variant-id')
    const isGiftBoxAdded = document.querySelector('#gift-box-for-product')
    const selectedGiftMessage = document.querySelector('#selected-gift-message')
    const mainVariantId = document.querySelector('#main__variantId')
    const giftVariantId = document.querySelector('#gift__variantId')
    const hasGiftBoxId = document.querySelector('#hasgiftboxId')
    const mainProductGroupId = document.querySelector('#main-product-groupId')
    const giftProductGroupId = document.querySelector('#gift-box-groupId')
    const giftProductAddon = document.querySelector('#gift-box-addon')
    const giftProductAddonType = document.querySelector('#gift-box-addon-type')

    updateGiftGroupIdInputs()

    // Only update product page elements if they exist (not in cart drawer context)
    if (giftBoxContent && giftBox) {
      if (giftBoxVariantInput) giftBoxVariantInput.disabled = false
      if (isGiftBoxAdded) isGiftBoxAdded.disabled = false
      if (selectedGiftMessage) selectedGiftMessage.disabled = false
      if (mainVariantId) mainVariantId.disabled = false
      if (giftVariantId) giftVariantId.disabled = false
      if (hasGiftBoxId) hasGiftBoxId.disabled = false
      if (mainProductGroupId) mainProductGroupId.disabled = false
      if (giftProductGroupId) giftProductGroupId.disabled = false
      if (giftProductAddon) giftProductAddon.disabled = false
      if (giftProductAddonType) giftProductAddonType.disabled = false
    } else {
      if (giftBoxVariantInput) giftBoxVariantInput.disabled = true
      if (isGiftBoxAdded) isGiftBoxAdded.disabled = true
      if (selectedGiftMessage) selectedGiftMessage.disabled = true
      if (mainVariantId) mainVariantId.disabled = true
      if (giftVariantId) giftVariantId.disabled = true
      if (hasGiftBoxId) hasGiftBoxId.disabled = true
      if (mainProductGroupId) mainProductGroupId.disabled = true
      if (giftProductGroupId) giftProductGroupId.disabled = true
      if (giftProductAddon) giftProductAddon.disabled = true
      if (giftProductAddonType) giftProductAddonType.disabled = true
    }

    if (giftBox && selectedGiftMessage) {
      selectedGiftMessage.disabled = false;
    } else if (selectedGiftMessage) {
      selectedGiftMessage.disabled = true;
    }
  }

  /**
   * Update the Group ID hidden inputs with a new timestamp to ensure the group
   * id is always unique.
   */
  function updateGiftGroupIdInputs() {
    const timestamp = GiftUtils.generateGroupId()
    const mainProductGroupId = document.querySelector('#main-product-groupId')
    const giftProductGroupId = document.querySelector('#gift-box-groupId')

    if (mainProductGroupId) {
      mainProductGroupId.value = timestamp
    }

    if (giftProductGroupId) {
      giftProductGroupId.value = timestamp
    }
  }

  // Update the hidden input field when the user confirms their gift box selection
  const confirmGifting = document.querySelector('#confirm-gifting')

  if (confirmGifting) {
    confirmGifting.addEventListener('click', function () {
      checkGiftBoxSelection()
    })

    /**
     * Update Group ID inputs on variant change.
     */
    subscribe(PUB_SUB_EVENTS.variantChange, () => {
      updateGiftGroupIdInputs()
    })
  }

  // Initial check on page load
  const giftBoxInput = document.querySelector('#selected-gift-box')

  if (giftBoxInput) {
    checkGiftBoxSelection()
  }
})
